var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#905419;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.23,20.86a1.81,1.81,0,0,0-1.6-.5.62.62,0,0,0-.89-.85.62.62,0,0,0-.88-.88.62.62,0,0,0,0-.87.65.65,0,0,0-.23-.15l1.12-1.12.3-2L21.51,14l-1,2.05-1.37,1.36.35-.35a2,2,0,0,1-.43-2.43L18,13.48l-1.83,1.83-1.84,1.83,1.12,1.12a2,2,0,0,1,2.44.44l0,0-1,1-2.05,1,.54.55,2-.3,1.12-1.12a.61.61,0,0,0,.15.24.62.62,0,0,0,.87,0,.62.62,0,0,0,.88.88.62.62,0,0,0,.84.9,1.79,1.79,0,0,0,.5,1.6,1.81,1.81,0,1,0,2.56-2.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.41,12.21l1.84-1.83,1.83-1.83L10.26,5.72a10.2,10.2,0,0,0-6.63-3,10.17,10.17,0,0,0,3,6.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.15,19a2,2,0,0,1,2.43-.43l8.9-8.85a10.22,10.22,0,0,0,3-6.63,10.21,10.21,0,0,0-6.64,3L7.93,14.93a2,2,0,0,1-.44,2.43l-1-1-1-2.06L5,14.84l.29,2,1.12,1.12a.79.79,0,0,0-.23.14.61.61,0,0,0,0,.88.62.62,0,0,0-.88.88.62.62,0,0,0-.9.84,1.79,1.79,0,0,0-1.61.5,1.81,1.81,0,1,0,3.06,1,.62.62,0,0,0,.85-.89.62.62,0,0,0,.88-.88.63.63,0,0,0,.88,0,.62.62,0,0,0,.14-.23L9.7,21.25l2,.3.55-.55-2.05-1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFarm);
export default __webpack_public_path__ + "static/media/menu_farm.154d9b2e.svg";
export { ForwardRef as ReactComponent };